import {
  and,
  catalog_product,
  desc,
  eq,
  type PowerSyncDrizzleDB,
  sql,
  user_collection,
} from "@famidex/powersync";
import { liveCollectionFilters } from "../live/filters";

/**
 * 🎯 Colección VIVA del usuario, con la metadata del catálogo (join local [L] ×
 * global [H]). Ordenada por adquisición reciente. Filtrada por la capa live
 * (sin filas de la papelera).
 */
export function getCollectionQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      id: user_collection.id,
      product_id: user_collection.product_id,
      state: user_collection.state,
      quantity: user_collection.quantity,
      condition: user_collection.condition,
      notes: user_collection.notes,
      acquired_at: user_collection.acquired_at,
      updated_at: user_collection.updated_at,
      edition_name: catalog_product.edition_name,
      category: catalog_product.category,
      series_id: catalog_product.series_id,
      image_url: catalog_product.image_url,
      is_limited: catalog_product.is_limited,
    })
    .from(user_collection)
    .leftJoin(catalog_product, eq(user_collection.product_id, catalog_product.id))
    .where(and(eq(user_collection.user_id, userId), ...liveCollectionFilters()))
    .orderBy(desc(user_collection.acquired_at), desc(user_collection.updated_at));
}

/**
 * Filas base del PROGRESO POR SERIE: productos DISTINTOS poseídos por serie.
 * Combínalas con `catalog_series.total_items` vía `computeAllSeriesProgress`
 * (lógica pura). Sólo estado `owned` cuenta hacia completar la serie.
 */
export function getSeriesProgressRowsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      series_id: catalog_product.series_id,
      owned: sql<number>`COUNT(DISTINCT ${user_collection.product_id})`,
    })
    .from(user_collection)
    .innerJoin(catalog_product, eq(user_collection.product_id, catalog_product.id))
    .where(
      and(
        eq(user_collection.user_id, userId),
        eq(user_collection.state, "owned"),
        ...liveCollectionFilters(),
      ),
    )
    .groupBy(catalog_product.series_id);
}

/**
 * Lookup id/product-scoped del UPDATE-or-INSERT (gotcha #15: las vistas
 * PowerSync no admiten UPSERT). Resuelve la fila existente por (usuario,
 * producto) — incluida la borrada, para «des-borrarla» al re-añadir. `keyed` en
 * el guard-manifest.
 */
export function getCollectionItemByProductQuery(
  db: PowerSyncDrizzleDB,
  userId: string,
  productId: string,
) {
  return db
    .select()
    .from(user_collection)
    .where(and(eq(user_collection.user_id, userId), eq(user_collection.product_id, productId)))
    .limit(1);
}
